module.exports = __webpack_public_path__ + "img/DV-logo.13017c60.svg";